export enum OrderStatus {
  Input = 'input',
  AwaitingPayment = 'awaiting_payment',
  Paid = 'paid',
}
